// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2iQJ-","col":"styles_col__2nUkp"};